module.exports = __webpack_public_path__ + "static/media/search.5437e521.svg";